// region Please kill jQuery

// import $ from 'jquery';
// import {Foundation} from 'foundation-sites/js/foundation.core';
// import {MediaQuery} from 'foundation-sites/js/foundation.util.mediaQuery';

// Set up Foundation with jQuery.
// Foundation.addToJquery($);
// Foundation JS init here:
// Foundation.MediaQuery = MediaQuery;

// ...
// $(document).foundation();
// // Add jQuery to window for temp back compat.
// window.$ = $;

// endregion

import * as Tools from './tools';

import 'lazysizes';
import initAnalytics from './analytics/analytics';
import initLightbox from './plugins/lightbox';
import initMenu from './plugins/menu';
import {initInviewObserver} from "./IntersectionObserver";
import {initModal} from './plugins/modal';
import {
    initHomePageSlider,
    initGalleryElementCarousel1,
    initGalleryElementCarousel2,
    initEmployeeSlider, initBrandsCarousel, initShortcutCarousel, initProductListCarousel
} from './plugins/carousels'
import {initAnimationObserver} from "./plugins/animation";
import {initSweetAlert} from "./plugins/sweetalert";
import initPageform from "./plugins/pageform";
import initListFilter from "./plugins/listfilter";
import {initStickyHeader} from "./plugins/stickyheader";
import initGlobal from "./plugins/global";
import {initCheckout} from "./plugins/checkout";
import {initPriceSwitch} from "./plugins/priceswitch";
import {initProductFavorites} from "./plugins/product-favorites";
import {initFacetReveal} from "./plugins/facetreveal";
import {initProductMoreDetails} from "./plugins/productmoredetails";
import {initTabs} from "./plugins/tabs";
import {initNumericFieldPlusMinus} from "./plugins/numericfieldplusminus";
import {initSearch} from "./plugins/search";
import {initProductFilter} from "./plugins/productfilter";
import initCart from "./plugins/cart";
import {DoubleSubmitButtonDisable} from "./plugins/doublesubmit";

window.Tools = Tools;

document.addEventListener('DOMContentLoaded', () => {
    initPriceSwitch();
    initCheckout();
    initGlobal();
	initAnalytics();
    initInviewObserver();
    initAnimationObserver();
    initSweetAlert();
	initPageform();
    initLightbox();
	initMenu();
    initStickyHeader();
	initModal();
    initHomePageSlider();
    initEmployeeSlider();
    initGalleryElementCarousel1();
    initGalleryElementCarousel2();
    initListFilter();
    initBrandsCarousel();
    initCart();
    // initAddProductCartModal();
    initFacetReveal();
    initProductMoreDetails();
    initTabs();
    initNumericFieldPlusMinus();
    initSearch();
    initShortcutCarousel();
    initProductFavorites();
    initProductListCarousel();

    // TODO: Remove before live.
    initProductFilter();
    DoubleSubmitButtonDisable();
});

// If in development mode, enable live reload
if (ENV !== 'production') {
    document.write(
        '<script src="http://' + (location.host || 'localhost').split(':')[0] +
        ':35729/livereload.js?snipver=1"></' + 'script>'
    );
}

//Focus on Search window load
// window.onload = function() {
//     var input = document.getElementById("SearchForm_SearchForm_Search");
//     if (input) {
//         input.setAttribute("placeholder", "Enter a search phrase here");
//         input.focus();
//         var val = input.value; //store the value of the element
//         input.value = ''; //clear the value of the element
//         input.value = val; //set that value back.
//     }
// }
